module.exports = "../dist/frontend/icons/benefits/green/card-valid.svg?e5bf813763869a60e89689902831f7b8";